// frontend/modules/template/index.ts
import { ModuleConfig } from '@/core/module';
import { templateRoutes } from './routes';
import { useTemplateStore } from './stores/template-store';
import { useContextScriptStore } from './stores/context-script-store';
import { useContextBuilderStore } from './stores/context-builder-store';

// Export hooks
export { useContextScripts } from './hooks/useContextScripts';
export { useContextTransformation } from './hooks/useContextTransformation';
export { useScriptTesting } from './hooks/useScriptTesting';

// Export components
export { ContextScriptEditor } from './components/ContextScriptEditor';
export { ContextScriptList } from './components/ContextScriptList';
export { ContextTransformationForm } from './components/ContextTransformationForm';
export { ScriptTestingPanel } from './components/ScriptTestingPanel';
export { TransformationResultPreview } from './components/TransformationResultPreview';
export { ImportExportScripts } from './components/ImportExportScripts';

// Export views
export { ContextScriptListView } from './views/ContextScriptListView';
export { ContextScriptEditView } from './views/ContextScriptEditView';
export { ContextScriptViewView } from './views/ContextScriptViewView';
export { ContextTransformationView } from './views/ContextTransformationView';

export const TemplateModule: ModuleConfig = {
    name: 'template',
    routes: templateRoutes,
    stores: {
        template: useTemplateStore,
        contextScript: useContextScriptStore,
        contextBuilder: useContextBuilderStore
    },
    initialize: () => {
        console.log('Template module initialized');
    }
};